import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => undefined,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.TableColumn) =>
    kontentAiDataMapping.table_column(entry),
};
